
import type { PropOptions } from 'vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'PublicPortfolioAward',
  props: {
    year: {
      type: [Number, String],
      default: 2021,
    } as PropOptions<number | string>,
    name: {
      type: String,
      default: 'Top Rep Q3 Award',
    } as PropOptions<string>,
  },
  computed: {
    rootClass(): Record<string, boolean> {
      return {
        'public-portfolio-award': true,
      };
    },
  },
});
